/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { SelectUploaderPayload } from './upload.model';

export class SelectUploader {
    static readonly type = '[Upload] Select Uploader';

    constructor(public payload: SelectUploaderPayload) {}
}
